import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";

const fetchSystemIds = async () => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");

  const temp = JSON.parse(userDetails);

  try {
    const response = await axios.get(
      `${API_BASE_PATH}/KeyLogging/systemIds/${temp.companyid}`,
    );
    return response.data;
  } catch (error) {
    console.error(error?.response?.data?.error || error.message);
    throw new Error(error?.response?.data?.error || "Failed to fetch system IDs");
  }
};
const useSystemidQuery = (options = {}) => {
  return useQuery({
    queryKey: ["systemsid"], // unique cache key
    queryFn: fetchSystemIds, // correct property for useQuery
    ...options, // allow passing extra react-query options
    enabled: options.enabled !== false,
  });
};

export default useSystemidQuery;
